    import React from "react";
    import { Card, Badge, Button } from "antd";
    import ShowRole from "./ShowRole";
    import EditRole from "./EditRoleButton";
    import DeleteRole from "./DeleteRoleButton";
    import { Grid } from "@material-ui/core";

    export const RoleCard = ({ item }) => {
        return (
            <Card
                title={<Badge status="processing" text={item.name} />}
                style={{
                    marginBottom: 15,
                    minWidth: 300,
                    boxShadow: "1px 1px 1px #9E9E9E",
                    borderRadius: "5px",
                }}
                bordered={true}
                actions={[
                    <ShowRole item={item} key="view" />,
                    <EditRole item={item} key="edit" />,
                    <DeleteRole item={item} key="delete" />,
                ]}
            >
                <Grid container direction="column" justify="center" alignItems="center">
                    <h1>{item.name}</h1>
                </Grid>
            </Card>
        );
    };

    export default RoleCard;
